import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getActiveUser,
  getChildKnot,
  getGuardianChilds,
  getUser,
  getUserDetail,
  getUserGuardians,
  getUserLocation,
  getUserMatches,
  getUserNotification,
  getUserReports,
  getUserSuggested,
  imageStatusManage,
  profileImageStatus,
  statusManageUser,
} from "store/services/users";
import { updateUserStatus } from "store/slices/admin/dataManagement/maliciousWords";
import {
  updateExtraImageStatus,
  updateImageStatus,
  updateUserStatusManage,
} from "store/slices/admin/users";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All User
export const GetAllUserAction = createAsyncThunk(
  "user/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUser(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetActiveUserAction = createAsyncThunk(
  "user/getActiveUser",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getActiveUser();
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserNotificationAction = createAsyncThunk(
  "user/getUserNotification",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserNotification(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserLocationAction = createAsyncThunk(
  "user/getUserLocation",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserLocation(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete User
export const StatusManageUserAction = createAsyncThunk(
  "user/statusManage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSucess, onError, ...rest } = payload;
      const res = await statusManageUser(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        onSucess?.();
        dispatch(closeAdminModal());
        dispatch(updateUserStatus(rest));
        dispatch(updateUserStatusManage(rest));
        const responce = await getUser(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      onError?.();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      )
      return rejectWithValue(error);
    }
  },
);

//Get User detail
export const GetUserDetailAction = createAsyncThunk(
  "user/detail",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserDetail(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserMatches = createAsyncThunk(
  "user/matches",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserMatches(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ProfileImageStatus = createAsyncThunk(
  "user/imageStatus",
  async (payload, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
      const res = await profileImageStatus(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(updateImageStatus(payload));
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserReports = createAsyncThunk(
  "userReport/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserReports(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserGuardians = createAsyncThunk(
  "userGuardians/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserGuardians(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetGuardianDetailAction = createAsyncThunk(
  "guardian/detail",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserDetail(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetGuardianChilds = createAsyncThunk(
  "guardianChilds/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getGuardianChilds(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetChildKnot = createAsyncThunk(
  "childKnot/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getChildKnot(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetUserSuggested = createAsyncThunk(
  "userSuggested/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserSuggested(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ImageStatusManage = createAsyncThunk(
  "user/imageStatus",
  async (payload, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
      const res = await imageStatusManage(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(updateExtraImageStatus(payload));
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
